import { LoadingButton } from "@mui/lab";
import { Box, Paper } from "@mui/material";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { ExtraProjectDetailDto, ProjectService } from "../../../api/psc";
import { CardInformation } from "../../../components/exports";
import { UserContext } from "../../../contexts/UserContext";
import { RootState } from "../../../slices/Store";
import { toJalaliDate } from "../../../utils/date";

export default function ProjectDetailExtraInfo() {
    const user = useContext(UserContext);

    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const [projectExtraInfo, setProjectExtraInfo] =
        useState<ExtraProjectDetailDto | null>(null);
    const [fetchingExtraInfo, setFetchingExtraInfo] = useState(false);

    const fetchExtraInfo = () => {
        setFetchingExtraInfo(true);
        ProjectService.getExtraProjectDetails(
            projectDetailState.projectHashId,
            "1"
        )
            .then((r) => {
                setProjectExtraInfo(r);
            })
            .finally(() => {
                setFetchingExtraInfo(false);
            });
    };

    return (
        <>
            {projectDetailState.showExtraDetail && (
                <>
                    {projectExtraInfo !== null ? (
                        <Paper sx={{ p: 2, mb: 2 }}>
                            <CardInformation
                                title="تاریخ ایحاد"
                                value={toJalaliDate(
                                    projectExtraInfo.createDate
                                )}
                            />
                            <CardInformation
                                title="تاریخ به روز رسانی"
                                value={toJalaliDate(
                                    projectExtraInfo.lastUpdateDate
                                )}
                            />

                            <CardInformation
                                title="تاریخ تغییر مرحله"
                                value={toJalaliDate(
                                    projectExtraInfo.phaseLastUpdateDate
                                )}
                            />

                            {projectExtraInfo.constructorViewStats.map((c) => {
                                return (
                                    <Box key={c.name}>
                                        <CardInformation
                                            title={
                                                c.name + `(${c.acceptanceRate})`
                                            }
                                            value={c.viewCount}
                                        />
                                    </Box>
                                );
                            })}
                        </Paper>
                    ) : (
                        <LoadingButton
                            fullWidth
                            sx={{ mb: 2 }}
                            loading={fetchingExtraInfo}
                            variant="contained"
                            color="warning"
                            onClick={fetchExtraInfo}
                        >
                            مشاهده اطلاعات بیشتر ادمین
                        </LoadingButton>
                    )}
                </>
            )}
        </>
    );
}
